import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as articlesActions from '../../actions/articlesActionCreators';
import {Link, withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import constants from '../../constants';
import {useMount} from 'react-use';
import ArticlesList from '../../components/Articles/List';
import SeoTags from '../../routes/SeoTags';
import InfiniteScroll from "react-infinite-scroller";
import LoadingSpinner from '../../components/Loading';

const ArticlesPage = (props) => {
  const
    collection = props.articlesState.articles,
    paginator = props.articlesState.paginator,
    maxPage = Math.ceil(paginator.total / paginator.per_page),
    canLoadMore = !props.articlesState.preloading_next_articles_page && maxPage >= paginator.page,
    loadMoreArticles = () => {
      if (!canLoadMore) {
        return;
      }
      props.articlesActions.preloadNextPage();
    };

    // paginator = {
    //   ...props.articlesState.paginator,
    //   onChange: (page, per_page) => {
    //     props.articlesActions.fetchArticles({
    //       page,
    //       per_page
    //     });
    //   }
    // };

  useMount(() => {
    props.articlesActions.fetchArticles();
  });

  return (
    <Layout
      className='articles-page'
      breadcrumbs={[
        {label: 'Статьи'}
      ]}
    >
      <SeoTags
        controller_action='articles#index'
      />

      <div className='container'>
        <section className='page-content-section'>
          <InfiniteScroll
            pageStart={0}
            loadMore={loadMoreArticles}
            hasMore={canLoadMore}
            loader={
              <span key={0}/>
            }
            threshold={100}
          >

            <ArticlesList
              collection={collection}
              linkHelper={constants.ROUTES.REGIONAL_ARTICLE_PATH}
              idKey='id_with_slug'
            />
          </InfiniteScroll>
          {
            props.articlesState.preloading_next_articles_page ?
              <div className="products-loader" key={0}>
                <LoadingSpinner />
              </div>
              : null
          }
        </section>
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      articlesActions: bindActionCreators(articlesActions, dispatch)
    };
  },

  mapStateToProps = ({articlesState, railsContext, applicationState}) => {
    return {
      applicationState,
      articlesState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(ArticlesPage));
